/* eslint-disable camelcase */

export default api => {
  function postOutbound(transfer: Object) {
    return api.post(`/_svc/slapi-v1/transfer/outbound`, transfer);
  }

  function closeAsn(warehouse: Object) {
    return api.post(`/_svc/slapi-v1/transfers/asn/close`, warehouse);
  }

  function getTransfers(query, fromnoon, fbn) {
    return api.get(
      `/_svc/slapi-v1/${
        fbn ? "fbn-transfers" : `transfers/${fromnoon ? "fromnoon" : "tonoon"}`
      }?${query}`
    );
  }

  function getAsn(query, type, rtv) {
    return api.get(`/_svc/slapi-v1/transfers/${rtv || "asn"}?${query}`);
  }

  function getTransfersCount(query, rtv) {
    return api.get(
      `/_svc/slapi-v1/transfers/${rtv ? "rtv" : "asn"}/counts?${query}`
    );
  }

  function getFbnTransfersCount(query, rtv) {
    return api.get(`/_svc/slapi-v1/fbn-transfers/processed/counts?${query}`);
  }

  function openFbnAsn(whObj) {
    return api.post(`/_svc/slapi-v1/fbn-transfers/open`, whObj);
  }

  function importFbnAsn(file) {
    return api.post(`/_svc/slapi-v1/fbn-transfers/import`, file);
  }
  function scheduleAsn(obj) {
    return api.post(`/_svc/slapi-v1/fbn-transfers/schedule`, obj);
  }

  function getInitialLines(query, typeText) {
    return api.get(
      `/_svc/slapi-v1/fbn-transfers/${typeText || "initial"}/lines?${query}`
    );
  }

  function getProcessedLines(query, scheduled) {
    return api.get(
      `/_svc/slapi-v1/fbn-transfers/${
        scheduled ? "scheduled" : "processed"
      }/lines?${query}`
    );
  }

  function getAsnBatches(query) {
    return api.post(`/_svc/slapi-v1/fbn-transfers/batches`, query);
  }

  function retrieveSlots(obj) {
    return api.post(`/_svc/slapi-v1/fbn-transfers/slots`, obj);
  }

  function exportEligibleOffers() {
    return api.get(`/_svc/slapi-v1/reports/export/eligible-fbn-offers`);
  }

  function getStatus() {
    return api.get(`/_svc/slapi-v1/transfers/tonoon/statuses`);
  }

  function getRtvStatuses() {
      return api.get(`/_svc/slapi-v1/transfers/fromnoon/statuses`);
  }

  return {
    postOutbound,
    getTransfers,
    getAsn,
    getTransfersCount,
    closeAsn,
    openFbnAsn,
    getInitialLines,
    importFbnAsn,
    scheduleAsn,
    exportEligibleOffers,
    getProcessedLines,
    getAsnBatches,
    getFbnTransfersCount,
    retrieveSlots,
    getStatus,
    getRtvStatuses
  };
};



// WEBPACK FOOTER //
// ./src/services/TransferService.js